import { MAP_TYPES } from '@deck.gl/carto';

const SUMTOTALJOBSDIFF_HOUSEHOLDSINNOAAFLOODHIGH2070DIFF_JOBACCESS45MINUTETRANSITDIFF_SOURCE_ID =
  'sumTotalJobsDiff_HouseholdsInNoaaFloodHigh2070Diff_JobAccess45MinuteTransitDiffSource';

const source = {
  id: SUMTOTALJOBSDIFF_HOUSEHOLDSINNOAAFLOODHIGH2070DIFF_JOBACCESS45MINUTETRANSITDIFF_SOURCE_ID,
  type: MAP_TYPES.TILESET,
  connection: 'bmpo-smartmetro-09142026',
  data: 'us-con-gcp-npr-0000424-011325.bmpo_curated_dev.BMPO_tileset_05',
};

export default source;
